/**
 * rfq.js — bảng dòng hàng của trang Send an RFQ.
 *
 *  · "Add a part" nhân bản khuôn <template data-rfq-template>, thay __i__ bằng số thứ tự
 *    để id/for của label vẫn duy nhất.
 *  · Dòng nào đã điền thì Model và Quantity của chính dòng đó thành bắt buộc,
 *    dòng để trống thì bỏ qua — người dùng không phải xoá dòng thừa trước khi gửi.
 *  · Nút gửi chỉ mở khi form hợp lệ (giống mẫu tham khảo).
 *
 * Trạng thái "đang gửi" nằm ở form-loading.js — dùng chung cho cả ba form.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var form = document.querySelector('[data-rfq]');
    if (!form) return;

    var rows = form.querySelector('[data-rfq-rows]');
    var template = form.querySelector('[data-rfq-template]');
    var addButton = form.querySelector('[data-rfq-add]');
    var submit = form.querySelector('[data-rfq-submit]');
    var fileInput = form.querySelector('[data-rfq-file]');
    var fileName = form.querySelector('[data-rfq-file-name]');
    var fileHint = fileName ? fileName.textContent : '';
    var MAX_ROWS = 30;
    var counter = rows ? rows.querySelectorAll('[data-rfq-row]').length : 0;

    function rowList() {
        return [].slice.call(rows.querySelectorAll('[data-rfq-row]'));
    }

    // Dòng đầu luôn bắt buộc; các dòng sau chỉ bắt buộc khi đã nhập gì đó
    function syncRequired() {
        rowList().forEach(function (row, index) {
            var inputs = [].slice.call(row.querySelectorAll('input'));
            var filled = inputs.some(function (input) {
                return input.value.trim() !== '';
            });

            inputs.forEach(function (input) {
                var key = input.name.replace('[]', '');
                if (key !== 'model' && key !== 'qty') return;
                input.required = index === 0 || filled;
            });
        });
    }

    function syncSubmit() {
        if (submit) submit.disabled = !form.checkValidity();
    }

    function syncRemoveButtons() {
        if (rowList().length > 1) {
            rows.removeAttribute('data-single');
        } else {
            rows.setAttribute('data-single', '');
        }
    }

    function addRow() {
        if (!template || rowList().length >= MAX_ROWS) return;

        counter++;
        var fragment = template.content.cloneNode(true);
        var row = fragment.querySelector('[data-rfq-row]');

        [].slice.call(row.querySelectorAll('[id], [for]')).forEach(function (el) {
            if (el.id) el.id = el.id.replace('__i__', counter);
            var target = el.getAttribute('for');
            if (target) el.setAttribute('for', target.replace('__i__', counter));
        });

        rows.appendChild(row);
        syncRemoveButtons();
        syncRequired();
        syncSubmit();

        var first = row.querySelector('input');
        if (first) first.focus();
    }

    if (addButton) addButton.addEventListener('click', addRow);

    // Xoá dòng — uỷ quyền sự kiện nên dòng mới thêm cũng chạy
    rows.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-rfq-remove]') : null;
        if (!button || rowList().length <= 1) return;

        var row = button.closest('[data-rfq-row]');
        if (row) row.parentNode.removeChild(row);

        syncRemoveButtons();
        syncRequired();
        syncSubmit();
    });

    // ----- Tải danh sách -----
    if (fileInput && fileName) {
        fileInput.addEventListener('change', function () {
            var file = fileInput.files && fileInput.files[0];
            fileName.textContent = file ? file.name : fileHint;
        });
    }

    // ----- Trạng thái nút gửi -----
    form.addEventListener('input', function () {
        syncRequired();
        syncSubmit();
    });
    form.addEventListener('change', syncSubmit);

    // Trạng thái "đang gửi" (khoá nút, vòng quay, đổi nhãn) do form-loading.js lo cho cả
    // ba form — trước đây khối đó nằm ở đây và chỉ chạy cho riêng form này.

    syncRemoveButtons();
    syncRequired();
    syncSubmit();
})();
